import { ChangeEvent, useRef, useState } from "react";
import "./podcast.scss";
import { IPodCastResponseModel } from "../../core/models";

export interface IPodcastProps {
  content: IPodCastResponseModel;
}

const Podcast = ({ content }: IPodcastProps) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState("0");
  const [currentTime, setCurrentTime] = useState(0);
  const [playbackRate, setPlaybackRate] = useState("1.0");
  const [percentage, setPercentage] = useState(0);

  const formatTime = (time: number): string => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const togglePlay = () => {
    if (window && (window as any)["ReactNativeWebView"]) {
      (window as any)["ReactNativeWebView"].postMessage(
        JSON.stringify({
          message: "eventLogForCountly",
          eventName: "Dinle Butonu",
          eventSegment: { baslik: content?.title },
          actionType: "event",
        })
      );
    }

    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const audioRef = useRef<HTMLAudioElement>(null);

  const getCurrDuration = ({
    currentTarget,
  }: ChangeEvent<HTMLAudioElement>) => {
    const target = currentTarget as HTMLAudioElement;
    if (target) {
      const percent = ((target.currentTime / target.duration) * 100).toFixed(2);

      const time = target.currentTime;

      setPercentage(+percent);
      setCurrentTime(parseFloat(time.toFixed(2)));
    }
  };

  const changePlaybackRate = () => {
    if (!audioRef.current) {
      return;
    }

    const newRate =
      parseFloat(playbackRate) >= 2 ? 1 : parseFloat(playbackRate) + 0.5;
    audioRef.current.playbackRate = newRate;
    setPlaybackRate(
      newRate === 1 || newRate === 2
        ? newRate.toString() + ".0"
        : newRate.toString()
    );
  };

  const skip = (time: "prev" | "next") => {
    const audio: HTMLAudioElement | null = audioRef.current;

    if (audio) {
      if (time == "prev") {
        // changes
        audio.currentTime = audio.currentTime - 10;
      } else if (time == "next") {
        // changes
        audio.currentTime = audio.currentTime + 10;
      }
    }
  };

  return (
    <section className="podcast">
      <div className="podcast-action">
        <div className="podcast-action__play">
          {isPlaying ? (
            <button className="stop" onClick={togglePlay}>
              <img
                src={"/icons/stop.svg"}
                width={40}
                height={40}
                alt={"stop"}
                style={{ height: "auto", width: "40px" }}
              />
            </button>
          ) : (
            <button className="icon icon-play" onClick={togglePlay}></button>
          )}

          <span className="podcast-action__play-title">{content.title}</span>
        </div>
        <div className="podcast-action__speed">
          <button
            className="podcast-action__speed-prev"
            onClick={() => skip("prev")}
          >
            <img
              src={"/icons/prev.svg"}
              width={24}
              height={24}
              alt={"prev 10 sec"}
            />
          </button>
          <button
            className="podcast-action__speed-next"
            onClick={() => skip("next")}
          >
            <img
              src={"/icons/next.svg"}
              width={24}
              height={24}
              alt={"next 10 sec"}
            />
          </button>
          <button
            className="podcast-action__speed-button"
            onClick={changePlaybackRate}
          >
            {playbackRate}x
          </button>
        </div>
      </div>
      <audio
        ref={audioRef}
        onTimeUpdate={getCurrDuration}
        onLoadedData={(event: ChangeEvent<HTMLAudioElement>) => {
          setDuration(event.currentTarget.duration.toFixed(2));
        }}
        src={content.url}
      ></audio>
      <div className="podcast-timer">
        <span className="podcast-timer__currenct">
          {formatTime(currentTime)}
        </span>
        <div className="podcast-timer__slider">
          <span
            className="podcast-timer__slider-current"
            style={{ "--percent": percentage + "%" } as React.CSSProperties}
          ></span>
        </div>
        <span className="podcast-timer__duration">
          {formatTime(parseFloat(duration))}
        </span>
      </div>
    </section>
  );
};

export default Podcast;
